import { BtnWrapper, HeroLeft, HeroWrapper } from 'src/components/Hero/elements';
import {
  BulletsPoints,
  ProNextSessionsIntraCompany,
  TrainingCard,
} from 'src/components/CorporateCourses/index';
import {
  HeaderDescription,
  HeaderTitle,
  Paragraph,
  SectionTitle,
  SubtitleDescription,
  TextContainer,
  UppercaseWords,
} from 'src/components/Typography';
import { Section, SectionOverlap, TwoColumns } from 'src/components/Section';
/* --- import Utils ----*/
import { dayMonthYearFromDate, formatDay } from 'src/utils/helpers';

import { AnchorButton } from 'src/components/Button';
import { FounderAvatar } from 'src/components/Founders/index';
import { GoogleReviews } from 'src/components/GoogleReview';
import { GatsbyImage } from 'gatsby-plugin-image';

/* --- import Components ----*/
import Layout from 'src/components/Layout';
import LogoProTechno from 'src/components/Icons/LogoProTechno';
import MoonCropped from 'src/components/Illustrations/MoonCropped.svg';
import { PartnersProSection } from 'src/components/Partners';
import { ProgramPro } from 'src/components/CorporateCourses';
import React from 'react';
import { TagContainer } from 'src/components/Tags/elements';
import { TopbarStaticSpace } from 'src/components/Topbar';
import colors from 'src/style/colors';
import { graphql } from 'gatsby';
import { isAfter } from 'date-fns';
import Tag from 'src/components/Tags/Tag';
import { GalaxyIllustrationWrapper } from 'src/components/Bootcamp/Schedule/Program/elements';
import { GalaxyIllustration } from 'src/components/Bootcamp/Schedule/Program';
/* --- import Style ----*/
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';

// const md = require('markdown-it')();
// const dedent = require('dedent-js');

const Course = ({ pageContext: { content, nextSessions }, location, data }) => {
  const {
    alt,
    description,
    duration,
    durationDays,
    goals,
    id,
    metaDescription,
    metaTitle,
    name,
    othersTraining,
    prerequisites,
    resume,
    summary,
    tags,
  } = content;
  // only react-redux has intra-sessions
  if (id !== 'react-redux' && id !== 'react-native' && id !== 'react-avance') nextSessions = [];

  const nextSessionsFiltered = (name) => {
    return nextSessions
      .filter(
        (session) => session.course.slug === name && !isAfter(new Date(), new Date(session.startAt))
      )
      .map((session) => {
        if (id === name) {
          const {
            day: startDateDay,
            month: startDateMonth,
            year: startDateYear,
          } = dayMonthYearFromDate(session.startAt);

          const {
            day: endDateDay,
            month: endDateMonth,
            year: endDateYear,
          } = dayMonthYearFromDate(session.endAt);

          const date = `${formatDay(startDateDay)} ${startDateMonth} ${
            startDateYear === endDateYear ? '' : startDateYear
          } au ${formatDay(endDateDay)} ${endDateMonth} ${endDateYear}`;

          return date;
        } else {
          return undefined;
        }
      });
  };

  const nextSession = nextSessionsFiltered(id);

  const isSessionName = nextSession[0] !== undefined ? id : false;

  const handlePrice = (name) => {
    return nextSessions
      .filter(
        (session) => session.course.slug === name && !isAfter(new Date(), new Date(session.startAt))
      )
      .map((item) => {
        if (id === name && item.prices && item.prices.length > 0) {
          return item.prices[0].price;
        } else {
          return undefined;
        }
      });
  };

  const handleDateDisplay = () => {
    if (isSessionName) {
      if (nextSession.length > 1) {
        return (
          <div
            css={{
              [mediaQueries.desktopUp]: {
                display: 'inline-block',
              },
            }}
          >
            <span
              css={{
                [mediaQueries.tabletLandscapeUp]: {
                  display: 'none',
                },
              }}
            >
              {' '}
              {nextSession[0]} <br />
              {nextSession[1]}
            </span>
            <span
              css={{
                display: 'none',
                [mediaQueries.tabletLandscapeUp]: {
                  display: 'inline-block',
                },
              }}
            >
              {nextSession.join(` et du `)}
            </span>
          </div>
        );
      } else {
        return nextSession;
      }
    } else {
      return undefined;
    }
  };

  return (
    <Layout
      pathname={location.pathname}
      businessType="B2B"
      pageName={content?.name}
      pageType="course"
      metaTitle={`${metaTitle} - ${duration} | Le Reacteur`}
      metaDescription={metaDescription}
    >
      <TopbarStaticSpace />
      {/* <HeroBG80vh> */}
      <Section theme="primary" hero={true} margin>
        <HeroWrapper notCentered>
          <HeroLeft css={{ flex: 1 }}>
            <LogoProTechno name={id} deviceDisplay="isMobile" />
            <HeaderTitle>
              Formation professionnelle
              <br />
              {name}
            </HeaderTitle>
            <TagContainer wrapped css={{ marginTop: '40px' }}>
              {tags
                ? tags.map((tag) => {
                    return (
                      <Tag key={tag.tagName} color={tag.color}>
                        {tag.tagName}
                      </Tag>
                    );
                  })
                : null}
            </TagContainer>
            <HeaderDescription
              css={{
                marginTop: 32,
                textAlign: 'center',
                [mediaQueries.desktopUp]: {
                  marginRight: 60,
                  textAlign: 'left',
                },
              }}
              dangerouslySetInnerHTML={{ __html: summary }}
            ></HeaderDescription>
            {isSessionName &&
            (id === 'react-redux' || id === 'react-native' || id === 'react-avance') ? (
              <HeaderDescription
                css={{
                  color: colors.yellow,
                  fontWeight: 'bold',
                }}
              >
                {nextSession.length > 1 && id
                  ? `Prochaines sessions :${' '}`
                  : `Prochaine session :${' '}`}
                <br
                  css={{
                    [mediaQueries.tabletPortraitUp]: {
                      display: 'none',
                    },
                  }}
                />
                {handleDateDisplay()}
              </HeaderDescription>
            ) : null}{' '}
            <BtnWrapper>
              <AnchorButton
                to="/devis/"
                state={{ fromFormationPage: id }}
                css={{
                  minWidth: 210,
                  marginRight: 16,
                  [mediaQueries.phoneOnly]: {
                    marginBottom: 16,
                    width: '100%',
                    marginRight: 0,
                  },
                }}
              >
                Demander un devis
              </AnchorButton>

              <AnchorButton
                secondary
                to="/contact/"
                css={{
                  minWidth: 210,
                  [mediaQueries.phoneOnly]: {
                    marginBottom: 16,
                    width: '100%',
                  },
                }}
              >
                Nous contacter
              </AnchorButton>
            </BtnWrapper>
          </HeroLeft>
          <LogoProTechno name={id} deviceDisplay="isDesktop" />
        </HeroWrapper>
      </Section>
      {/* </HeroBG80vh> */}

      {/* --- INTRO --- */}
      <SectionOverlap marginTop={-100} theme="secondary">
        <div css={{ paddingTop: 64 }}>
          <TwoColumns
            sizeLeft={sizes.columnWidth.large}
            left={
              <div>
                <SectionTitle>Présentation</SectionTitle>
                <TextContainer
                  css={{
                    '&>p': { paddingTop: 16 },
                    '&>p>a': { color: colors.purple, textDecoration: 'none' },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: resume,
                  }}
                />
                <GatsbyImage
                  image={
                    content && id === 'react-redux'
                      ? data.imageReactRedux.childImageSharp.gatsbyImageData
                      : content && id === 'react-native'
                      ? data.imageReactNative.childImageSharp.gatsbyImageData
                      : content && id === 'react-avance'
                      ? data.imageReactAvance.childImageSharp.gatsbyImageData
                      : content && id === 'typescript'
                      ? data.imageTypescript.childImageSharp.gatsbyImageData
                      : content && id === 'node-js'
                      ? data.imageNode.childImageSharp.gatsbyImageData
                      : undefined
                  }
                  alt={alt}
                  css={{
                    flex: 1,
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 5,
                    marginTop: 32,
                    boxShadow: '5px 20px 40px rgba(0, 0, 0, 0.2)',
                    [mediaQueries.phoneOnly]: {
                      height: '70%',
                    },
                    [mediaQueries.tabletPortraitUp]: {
                      height: '70%',
                    },
                    [mediaQueries.tabletLandscapeUp]: {
                      height: '85%',
                    },
                    [mediaQueries.desktopUp]: {
                      height: '100%',
                    },
                  }}
                />
              </div>
            }
            sizeRight={sizes.columnWidth.small}
            right={
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: colors.white,
                  padding: 45,
                  marginLeft: 16,
                  borderRadius: 5,
                  [mediaQueries.phoneOnly]: {
                    padding: 0,
                    marginTop: 32,
                    backgroundColor: colors.lightGrey,
                    marginLeft: 0,
                  },
                }}
              >
                <UppercaseWords css={{ fontSize: 14, paddingBottom: 22 }}>Objectifs</UppercaseWords>
                <BulletsPoints content={goals} h3 />
                <div css={{ height: 35 }} />
                <UppercaseWords css={{ fontSize: 14, paddingBottom: 22 }}>Prérequis</UppercaseWords>
                <BulletsPoints content={prerequisites} />
                <div css={{ height: 35 }} />
                <UppercaseWords css={{ fontSize: 14, paddingBottom: 22 }}>
                  Taux de satisfaction
                </UppercaseWords>
                <BulletsPoints content={'<ul><li>Plus de 100 personnes formées</li></ul>'} />
                <BulletsPoints
                  customStyles={{ marginLeft: -8, display: 'flex', alignItems: 'center' }}
                  content={
                    '<img style="margin-right: 13px;" alt="Google Reviews"src="/images/googlereview.png" width="30" height="30"/><span style="color: #5C48D3; font-weight: bold">4.9</span>/5 sur Google -&nbsp;<a style="color: #5C48D3; aria-label="Avis Google" text-decoration: none;" target="_blank" ref="noopener noreferrer nofollow" href="https://www.google.com/search?q=le+reacteur&rlz=1C5CHFA_enFR868FR870&oq=le+reacteur&aqs=chrome.0.69i59l2j0i395l2j69i60l3j69i65.5077j1j7&sourceid=chrome&ie=UTF-8#lrd=0x47e66d87bdd508bd:0x30c72c8479c40156,1"> 220+ avis</a>'
                  }
                />
              </div>
            }
          />
        </div>
      </SectionOverlap>

      {/* --- PROGRAM --- */}
      <ProgramPro program={description} days={durationDays} />

      <div
        css={{
          position: 'relative',
        }}
      >
        <GalaxyIllustrationWrapper>
          <GalaxyIllustration />
        </GalaxyIllustrationWrapper>
      </div>

      {/* --- TYPICAL DAY --- */}
      <Section theme="light">
        <div
          css={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* <SectionHeaderBlock css={{ maxWidth: 1045, marginBottom: 40 }}> */}
          <SectionTitle isMobileCenter isCenter css={{ paddingBottom: 60 }}>
            Méthodes mobilisées
          </SectionTitle>
          {/* </SectionHeaderBlock> */}
        </div>
        <div>
          <SubtitleDescription style={{ marginBottom: '18px' }}>
            Matinées Théoriques :
          </SubtitleDescription>
          <Paragraph>
            Chaque matin, vous participerez à des cours théoriques interactifs animés par notre
            formateur expert. Ces sessions sont conçues pour introduire les concepts clés, expliquer
            les diverses techniques de programmation et dissiper toute confusion ou ambiguïté. Notre
            objectif est de vous fournir une base solide pour vous préparer aux exercices pratiques
            de l’après-midi.
          </Paragraph>
          <SubtitleDescription style={{ margin: '25px 0 18px 0' }}>
            Après-midis Pratiques :
          </SubtitleDescription>
          <Paragraph>
            Les après-midis sont consacrées à la mise en pratique des connaissances acquises. Vous
            réaliserez des exercices concrets pour appliquer ce que vous avez appris, renforçant
            ainsi vos compétences. Ces sessions pratiques vous permettront de transformer les
            concepts théoriques en applications concrètes, offrant une expérience d’apprentissage
            complète et enrichissante.
          </Paragraph>
        </div>
      </Section>

      {/* --- FARID --- */}
      <Section theme="secondary">
        <TwoColumns
          sizeLeft={1}
          reverse={true}
          left={<FounderAvatar />}
          sizeRight={3}
          right={
            <Paragraph
              css={{
                textAlign: 'center',
                fontSize: 20,
                lineHeight: '33px',
                padding: 0,
                '& a': {
                  textDecoration: 'none',
                  color: colors.purple,
                },
                [mediaQueries.phoneOnly]: {
                  fontSize: 16,
                  lineHeight: '24px',
                },
              }}
            >
              « Après avoir découvert React et React Native en 2015, j'ai développé plusieurs
              bibliothèques open-source comptabilisant plus d'un million de{' '}
              <a
                href="https://www.npmjs.com/package/react-native-gifted-chat"
                target="_blank"
                rel="noopener noreferrer"
              >
                téléchargements
              </a>
              . J'ai très rapidement compris le potentiel de cette bibliothèque JavaScript et cela
              m'a naturellement amené à vouloir transmettre mes savoirs. Avec Xavier Colombel, mon
              associé avec qui nous avons créé Le Reacteur, nous avons pensé et conçu nos programmes
              de formation comme nous aurions aimé les suivre, avec une grande place accordée à la
              pratique. Nous avons depuis formé plus de 1000 personnes, particuliers ou
              professionnels, sur une techno que nous maîtrisons parfaitement : le JavaScript. »
            </Paragraph>
          }
        />
      </Section>

      {id !== 'typescript' && id !== 'node-js' ? (
        <GoogleReviews course={id} withoutAvatar isCorporatePage />
      ) : null}

      <PartnersProSection title="Nous les avons formés" theme="light" />

      <ProNextSessionsIntraCompany
        isSessionName={isSessionName}
        nextSession={nextSession}
        sessionPrice={handlePrice(id)}
        formationName={id}
      />

      <div>
        <Section theme="secondary">
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <SectionTitle isCenter>Découvrez les autres formations</SectionTitle>
            <Paragraph css={{ maxWidth: 800, paddingBottom: 64 }}>
              Vous êtes un professionnel et souhaitez monter en compétences sur JavaScript ? Nous
              proposons des formations dédiées aux développeurs expérimentés. D'une durée de 1 à 5
              jours, nos sessions sont dispensées en intra-entreprises.
            </Paragraph>
          </div>
          <div
            css={{
              [mediaQueries.phoneOnly]: {
                marginBottom: '10%',
              },
              [mediaQueries.tabletPortraitUp]: {
                marginBottom: '10%',
              },
              [mediaQueries.desktopUp]: {
                marginBottom: '15%',
              },
              [mediaQueries.bigDesktopUp]: {
                marginBottom: '10%',
              },
            }}
          >
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                zIndex: 2,
                justifyContent: 'space-between',
                marginBottom: '2%',
                [mediaQueries.tabletLandscapeUp]: {
                  flexDirection: 'row',
                },
              }}
            >
              {othersTraining.map((item) => {
                return <TrainingCard key={item.name} training={item} />;
              })}
            </div>
            <div
              css={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <AnchorButton
                to="/formations-professionnelles/"
                css={{
                  minWidth: 210,
                  marginRight: 16,
                  [mediaQueries.phoneOnly]: {
                    marginBottom: 16,
                    width: '100%',
                    marginRight: 0,
                  },
                }}
              >
                Voir toutes les formations
              </AnchorButton>
            </div>
          </div>
        </Section>
        <div css={{ position: 'relative' }}>
          <div
            css={{
              position: 'absolute',
              bottom: -4,
              left: 0,
              right: 0,
              zIndex: 1,
              margin: 'auto',
              [mediaQueries.phoneOnly]: {
                width: '100%',
              },
              [mediaQueries.tabletPortraitUp]: {
                width: '85%',
              },
              [mediaQueries.tabletLandscapeUp]: {
                width: '70%',
              },
              [mediaQueries.bigDesktopUp]: {
                maxWidth: 1000,
              },
            }}
          >
            <img src={MoonCropped} alt="illustration demi lune" css={{ width: '100%' }} />
          </div>
        </div>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Course',
            name: `${metaTitle} - ${duration}`,
            description: metaDescription,
            provider: {
              name: 'Le Reacteur',
              sameAs: [`https://www.lereacteur.io/bootcamp-javascript/formation/${id}`],
            },
          }),
        }}
      />
    </Layout>
  );
};

export default Course;

export const query = graphql`
  query {
    imageReactRedux: file(relativePath: { eq: "2023_students3.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
    imageReactNative: file(relativePath: { eq: "2023_screen3.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
    imageReactAvance: file(relativePath: { eq: "2023_students.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
    imageTypescript: file(relativePath: { eq: "2023_screen4.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
    imageNode: file(relativePath: { eq: "2023_screen2.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 80)
      }
    }
  }
`;
